<template>
  <!-- Image Background Layer -->
  <div id="avatar" class="image-background" data-speed="0.4"></div>

  <!-- Avatar Side Block -->
  <div id="avatar" class="avatar">
<div class="avatar__container d-flex flex-column justify-items-center gap-y-4">
      <!-- Foto -->
      <div class="avatar__block">
        <div class="avatar__image">
          <img src="@/assets/images/Anime2.png" alt="Farras Naufal - Personal Portfolio & Resume">
        </div>
      </div>

      <!-- Specialization -->
      <div class="avatar__block ">
        <h3>Farras Naufal</h3>
        <h5>Quality Assurance Engineer</h5>

      </div>



      <!-- Social Media -->
<div class="avatar__socials">
  <ul class="socials-square">
    <li class="socials-square__item">
      <a class="socials-square__link" href="https://github.com/farrasnaufalwork" target="_blank">
        <i class="fab fa-github"></i>
      </a>
    </li>
    <li class="socials-square__item">
      <a class="socials-square__link" href="https://gitlab.com/farrasnaufalwork" target="_blank">
        <i class="fab fa-gitlab"></i>
      </a>
    </li>
    <li class="socials-square__item">
      <a class="socials-square__link" href="https://www.linkedin.com/in/farrasnaufal/" target="_blank">
        <i class="fab fa-linkedin-in"></i>
      </a>
    </li>
    <li class="socials-square__item">
      <a class="socials-square__link" href="mailto:farrasnaufalwork@email.com" target="_blank">
        <i class="fas fa-envelope"></i>
      </a>
    </li>
  </ul>
</div>


    </div>
  </div>
</template>

<script>
</script>

<style scoped>
/* General Styles */


/* Social Links */
.socials-square {
  gap: 1rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 0;
}

.socials-square__item {
  list-style: none;
}

.socials-square__link {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 52px;
  height: 52px;
  border-radius: 0.75rem;

  /* GLASS EFFECT */
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.2);
  color: rgba(255, 255, 255, 0.9);
  font-size: 20px;

  transition: all 0.3s ease;
}

.socials-square__link:hover {
  transform: translateY(-2px) scale(1.05);
  background: rgba(255, 255, 255, 0.08);
  box-shadow: 0 0 16px rgba(128, 33, 191, 0.725);
  color: #23c7d9; /* efek highlight saat hover */
}


/* Responsive Styles */
@media (min-width: 768px) {


  .socials-square {
    gap: 2rem;
  }

  .socials-square__link {
    width: 42px;
    height: 42px;
  }

  .socials-square__link img {
    width: 30px;
    height: 30px;
  }
}

@media (max-width: 768px) {

  .socials-square {
    gap: 2rem;
  }

  .socials-square__link {
    width: 42px;
    height: 42px;
  }

  .socials-square__link img {
    width: 25px;
    height: 25px;
  }
}
</style>
